import keysToConstants from 'js/lib/keysToConstants';

export const MODAL_TYPES = keysToConstants(['COURSE', 'SPECIALIZATION', 'PROFESSIONAL_CERTIFICATE']);

export type OpenAidModalType = keyof typeof MODAL_TYPES;
